module.exports = __webpack_public_path__ + "static/img/mainbg-N011.1dea5b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main/mainbg-N011.png
// module id = 0U60
// module chunks = 1